import React from 'react';
import { getIosModalPresentationConfig, ModalDialogue } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { LoadingAnimation } from '../LoadingAnimation';
import { AccountDeletionSecondStep } from './components';
import { useAccountDeletion, useAccountDeletionContentfulData } from './hooks';

export const RequestAccountDeletionModal = (
  props: RequestAccountDeletionModalProps,
) => {
  const { visible, onClose, onSuccess } = props;

  const { t } = useLocalizationContext();

  const { body, isLoadingContentfulData } = useAccountDeletionContentfulData();

  const { isDeletingAccount, requestAccountDeletion } = useAccountDeletion({
    onClose,
    onSuccess,
  });

  return (
    <ModalDialogue
      size="medium"
      accessibilityLabel={t('account.delete.headline')}
      visible={visible}
      onRequestClose={onClose}
      fitHeight
      {...getIosModalPresentationConfig()}
    >
      {isLoadingContentfulData ? (
        <LoadingAnimation />
      ) : (
        <AccountDeletionSecondStep
          body={body}
          isDeletingAccount={isDeletingAccount}
          requestAccountDeletion={requestAccountDeletion}
        />
      )}
    </ModalDialogue>
  );
};

type RequestAccountDeletionModalProps = Readonly<{
  visible: boolean;
  onSuccess: () => void;
  onClose: () => void;
}>;
